import type { Instrument } from "./types";

export const instrumentLabels: Record<Instrument, string> = {
  banjo: "Banjo",
  guitar: "Guitar",
  mandolin: "Mandolin",
  uke: "Ukulele",
  ukebaritone: "Uke - Baritone",
};

const chordFingerPositions: Record<string, Record<string, string[]>> = {
  uke: {
    Ab: ["4 2 3 2"],
    Abm: ["1 3 x 2"],
    Ab7: ["1 3 2 3"],
    A: ["2 1 0 0"],
    Am: ["2 0 0 0"],
    Am7: ["0 0 0 0"],
    A7: ["0 1 0 0"],
    A7sus4: ["0 2 0 0"],
    A9: ["2 1 3 2"],
    Ab9: ["1 0 2 1"],
    Asus: ["2 2 3 0"],
    Asus4: ["2 2 3 0"],
    "Am/G": ["0 0 0 0"],
    Bb: ["3 2 1 1"],
    Bbm: ["3 1 1 1"],
    Bbm7: ["1 1 1 1"],
    B: ["4 3 2 2"],
    B7: ["2 3 2 2"],
    Bm: ["4 2 2 2"],
    Bm7: ["2 2 2 2"],
    Bb7: ["3 5 4 5"],
    "B/G": ["0 3 2 2"],
    Bbdim7: ["3 4 3 4"],
    C: ["0 0 0 3"],
    C7: ["0 0 0 1"],
    C9: ["3 0 0 1"],
    Cmaj7: ["0 0 0 2"],
    Cm: ["0 3 3 3"],
    "C#": ["1 1 1 4"],
    "C#m": ["1 1 0 0"],
    "C#7": ["6 8 7 8"],
    "C/B": ["4 4 3 3"],
    "C/D": ["7 7 8 7"],
    "C/G": ["0 0 0 3"],
    Cadd9: ["5 7 7 7"],
    Db: ["1 1 1 4"],
    Dbm: ["1 1 0 0"],
    D: ["2 2 2 0"],
    Dsus4: ["0 2 3 0"],
    Dm: ["2 2 1 0"],
    Dm7: ["2 2 1 3"],
    Dm9: ["5 4 1 5"],
    D7: ["2 2 2 3"],
    Dsus: ["x 2 5 x"],
    D7sus2: ["7 9 8 7"],
    "D/B": ["4 6 5 5"],
    "D/C#": ["6 6 5 5"],
    "D/F#": ["x 6 5 5"],
    Dmaj7: ["7 9 9 9"],
    Dbmaj7: ["6 8 8 8"],
    Eb: ["3 3 3 1"],
    Ebmaj7: ["3 3 3 5"],
    E: ["1 4 0 2"],
    E7: ["1 2 0 2"],
    Em: ["0 4 3 2"],
    "Em#5": ["x 4 3 3"],
    Em7: ["9 11 10 10"],
    Em6: ["9 11 9 10"],
    F: ["2 0 1 0"],
    F7: ["2 3 1 3"],
    "F#m": ["2 1 2 0"],
    "F#": ["x 6 6 4"],
    "F#/D": ["7 6 6 4"],
    "F#/G": ["0 1 2 1"],
    "F#m7": ["11 13 12 12"],
    Fmaj7: ["10 12 12 12"],
    F9: ["10 9 11 10"],
    Fadd9: ["10 12 12 12"],
    Gbm: ["2 1 2 0"],
    G: ["0 2 3 2"],
    G7: ["0 2 1 2"],
    Gm7: ["0 2 1 1"],
    "G#m": ["4 3 4 2"],
    "G#": ["1 3 x 3"],
    G6: ["0 2 0 2"],
    G9: ["0 2 1 2"],
    Gm: ["0 2 3 1"],
    Gmaj7: ["0 2 2 2"],
    Gb9: ["11 10 12 11"],
    "G#m7": ["1 3 2 2"],
    "G/F#": ["11 11 10 10"],
    "G/B": ["4 2 3 2"],
    "G/C": ["5 7 7 5"],
    "G/E": ["9 11 10 10"],
    "G/D": ["x 2 3 2"],
  },

  ukebaritone: {
    Ab: ["6 5 4 4"],
    Abm: ["6 4 4 4"],
    A: ["2 2 2 0"],
    Am: ["2 2 1 0"],
    Am7: ["2 0 1 0"],
    A7: ["2 0 2 0"],
    Ab7: ["4 5 4 4"],
    Ab9: ["4 5 4 6"],
    Asus: ["2 2 3 0"],
    Asus4: ["2 2 3 0"],
    "Am/G": ["2 2 1 0"],
    Bb: ["3 3 3 1"],
    Bbm: ["3 3 2 1"],
    B: ["4 4 4 2"],
    B7: ["1 2 0 2"],
    Bm: ["4 4 3 2"],
    Bb7: ["3 1 3 1"],
    "B/G": ["5 4 4 2"],
    Bbdim7: ["2 0 2 x"],
    C: ["2 0 1 0"],
    C7: ["2 3 1 0"],
    Cmaj7: ["2 0 0 0"],
    Cm: ["5 5 4 3"],
    "C#": ["6 6 6 4"],
    "C#7": ["6 4 6 4"],
    "C/B": ["2 0 1 0"],
    "C/D": ["0 0 1 0"],
    "C/G": ["2 0 1 0"],
    Cadd9: ["0 0 0 0"],
    Db: ["6 6 6 4"],
    "C#m": ["6 6 5 4"],
    Dbm: ["6 6 5 4"],
    D: ["0 2 3 2"],
    Dm: ["0 2 3 1"],
    Dm7: ["0 2 1 1"],
    D7: ["0 2 1 2 "],
    Dsus: ["0 2 3 3"],
    D7sus2: ["0 2 1 0"],
    "D/B": ["0 2 0 2"],
    "D/C#": ["4 2 3 2"],
    "D/F#": ["0 2 3 2"],
    Dmaj7: ["4 2 2 2"],
    Dbmaj7: ["3 1 1 1"],
    Eb: ["1 3 4 3"],
    E: ["2 1 0 0"],
    Em: ["2 0 0 0"],
    E7: ["0 1 0 0"],
    Em7: ["2 0 3 0"],
    "Em#5": ["6 6 5 4"],
    Ebmaj7: ["2 0 1 0"],
    Em6: ["2 0 2 0"],
    F: ["3 2 1 1"],
    F7: ["1 2 1 1"],
    "F#m": ["4 2 2 2"],
    "F#": ["4 3 2 2"],
    "F#/D": ["4 3 2 x"],
    "F#/G": ["x 0 2 3"],
    "F#m7": ["2 2 2 x"],
    Fmaj7: ["3 5 5 5"],
    F9: ["1 2 1 3"],
    Fadd9: ["2 0 1 0"],
    Gbm: ["4 2 2 2"],
    G: ["0 0 0 3"],
    G7: ["0 0 0 1"],
    "G#m": ["6 4 4 4"],
    "G#": ["6 5 4 4"],
    G6: ["5 3 3 3"],
    G9: ["0 2 0 1"],
    Gm: ["5 3 3 6"],
    Gm7: ["3 3 6 3"],
    Gmaj7: ["0 0 0 2"],
    Gb9: ["4 3 5 4"],
    "G#m7": ["4 4 4 x"],
    "G/F#": ["0 0 0 2"],
    "G/B": ["0 0 0 3"],
    "G/C": ["0 0 0 3"],
    "G/E": ["0 0 0 0"],
    "G/D": ["0 0 0 3"],
  },

  guitar: {
    X: ["x x x x x x"],
    O: ["0 0 0 0 0 0"],

    Ab: ["4 6 6 5 4 4"],
    Abm: ["4 6 6 4 4 4"],
    A: ["0 0 2 2 2 0"],
    Am: ["x 0 2 2 1 0"],
    Am7: ["x 0 2 0 1 0"],
    A7: ["0 0 2 0 2 0"],
    Ab7: ["4 6 4 5 4 4"],
    Ab9: ["4 6 4 5 4 6"],
    Asus: ["x 0 2 2 3 0"],
    Asus4: ["x 0 2 2 3 0"],
    "Am/G": ["3 0 2 2 1 0"],
    Bb: ["0 1 3 3 3 1"],
    Bbm: ["0 1 3 3 2 1"],
    B: ["2 2 4 4 4 2"],
    B7: ["0 2 1 2 0 2"],
    Bm: ["2 2 4 4 3 2"],
    Bb7: ["x 1 3 1 3 1"],
    "B/G": ["x x 5 4 4 2"],
    Bbdim7: ["x 1 2 0 2 x"],
    C: ["0 3 2 0 1 0"],
    C7: ["0 3 2 3 1 0"],
    Cmaj7: ["0 3 2 0 0 0"],
    Cm: ["3 3 5 5 4 3"],
    "C#": ["4 4 6 6 6 4"],
    "C#7": ["x 4 6 4 6 4"],
    "C/B": ["x 2 2 0 1 0"],
    "C/D": ["x x 0 0 1 0"],
    "C/G": ["3 3 2 0 1 0"],
    Cadd9: ["x 3 0 0 0 0"],
    Db: ["4 4 6 6 6 4"],
    "C#m": ["4 4 6 6 5 4"],
    Dbm: ["4 4 6 6 5 4"],
    D: ["0 0 0 2 3 2"],
    Dm: ["0 0 0 2 3 1"],
    Dm7: ["0 0 0 2 1 1"],
    D7: ["0 0 0 2 1 2 "],
    Dsus: ["x x 0 2 3 3"],
    D7sus2: ["x x 0 2 1 0"],
    "D/B": ["x 2 0 2 0 2"],
    "D/C#": ["x 4 4 2 3 2"],
    "D/F#": ["2 0 0 2 3 2"],
    Dmaj7: ["x 5 4 2 2 2"],
    Dbmaj7: ["x 4 3 1 1 1"],
    Eb: ["0 0 1 3 4 3"],
    E: ["0 2 2 1 0 0"],
    Em: ["0 2 2 0 0 0"],
    E7: ["0 2 0 1 0 0"],
    Em7: ["0 2 2 0 3 0"],
    "Em#5": ["4 4 6 6 5 4"],
    Ebmaj7: ["0 3 2 0 1 0"],
    Em6: ["0 2 2 0 2 0"],
    F: ["1 3 3 2 1 1"],
    F7: ["1 3 1 2 1 1"],
    "F#m": ["2 4 4 2 2 2"],
    "F#": ["2 4 4 3 2 2"],
    "F#/D": ["x 5 4 3 2 x"],
    "F#/G": ["3 1 x 0 2 3"],
    "F#m7": ["2 x 2 2 2 x"],
    Fmaj7: ["x x 3 5 5 5"],
    F9: ["1 3 1 2 1 3"],
    Fadd9: ["1 0 2 0 1 0"],
    Gbm: ["2 4 4 2 2 2"],
    G: ["3 2 0 0 0 3"],
    G7: ["3 2 0 0 0 1"],
    "G#m": ["4 6 6 4 4 4"],
    "G#": ["4 6 6 5 4 4"],
    G6: ["3 5 5 3 3 3"],
    G9: ["3 x 0 2 0 1"],
    Gm: ["x x 5 3 3 6"],
    Gm7: ["3 5 3 3 6 3"],
    Gmaj7: ["3 2 0 0 0 2"],
    Gb9: ["x x 4 3 5 4"],
    "G#m7": ["4 x 4 4 4 x"],
    "G/F#": ["2 2 0 0 0 2"],
    "G/B": ["x 2 0 0 0 3"],
    "G/C": ["x 3 0 0 0 3"],
    "G/E": ["0 2 0 0 0 0"],
    "G/D": ["x x 0 0 0 3"],
  },

  banjo: {
    Ab: ["0 1 1 1 1"],
    Abm: ["0 1 1 0 1"],
    Ab7: ["0 1 1 1 4"],
    A: ["0 2 2 2 2"],
    Am: ["0 2 2 1 2"],
    Am7: ["0 7 5 5 5"],
    A7: ["0 2 2 2 5"],
    A7sus4: ["0 2 2 4 5"],
    A9: ["0 5 4 5 7"],
    Ab9: ["0 4 3 4 6"],
    Asus: ["0 2 2 3 2"],
    Asus4: ["0 2 2 3 2"],
    Bb: ["0 3 3 3 3"],
    Bbm: ["0 3 3 2 3"],
    B: ["0 4 4 4 4"],
    B7: ["0 1 2 0 1"],
    Bm: ["0 4 4 3 4"],
    Bb7: ["0 3 3 3 6"],
    Bbdim7: ["0 8 6 8 8"],
    C: ["0 2 0 1 2"],
    C7: ["0 2 3 1 2"],
    C9: ["0 2 3 1 0"],
    "C#7": ["0 3 4 2 3"],
    Cadd9: ["0 2 0 1 0"],
    Cmaj7: ["0 2 4 1 2"],
    Cm: ["0 1 0 1 1"],
    "C#": ["0 3 1 2 3"],
    Db: ["0 3 1 2 3"],
    "C#m": ["0 2 1 2 2"],
    Dbm: ["6 6 6 5 6"],
    D: ["0 0 2 3 4"],
    Dsus2: ["0 0 2 3 2"],
    Dsus4: ["0 0 2 3 5"],
    Dm: ["0 0 2 3 3"],
    Dm7: ["0 0 2 1 3"],
    Dm9: ["0 0 5 5 3"],
    D7: ["0 0 2 1 4"],
    Dsus: ["0 0 2 3 5"],
    D7sus2: ["x 0 2 1 2"],
    Dmaj7: ["0 0 2 2 4"],
    Dbmaj7: ["0 6 6 6 10"],
    Eb: ["0 5 3 4 5"],
    Ebmaj7: ["0 1 3 3 5"],
    E: ["0 2 1 0 2"],
    E7: ["0 2 1 0 0"],
    Em: ["0 2 0 0 2"],
    Em7: ["0 0 0 0 2"],
    Em6: ["0 2 4 2 5"],
    F: ["0 3 2 1 3"],
    F7: ["0 3 2 1 1"],
    "F#m": ["0 4 2 2 4"],
    "F#": ["0 4 3 2 4"],
    "F#m7": ["0 2 2 2 4"],
    Fmaj7: ["0 3 2 1 2"],
    F9: ["0 3 2 4 5"],
    Fadd9: ["0 3 2 1 5"],
    Gbm: ["0 4 2 2 4"],
    G: ["0 0 0 0 0"],
    G7: ["0 0 0 0 3"],
    Gm7: ["0 5 3 3 3"],
    "G#m": ["0 1 1 0 1"],
    "G#": ["0 1 1 1 1"],
    G6: ["0 0 0 0 2"],
    G9: ["0 5 4 6 7"],
    Gm: ["0 5 3 3 5"],
    Gmaj7: ["0 0 0 0 4"],
    Gb9: ["0 4 3 5 6"],
    "G#m7": ["0 4 4 4 6"],
  },

  mandolin: {
    Ab: ["1 1 3 4"],
    Abm: ["4 6 6 4"],
    Ab7: ["1 1 3 2"],
    A: ["2 2 4 0"],
    Am: ["2 2 3 0"],
    Am7: ["2 2 3 3"],
    A7: ["2 2 4 3"],
    A7sus4: ["0 0 0 0"],
    A9: ["4 5 4 5"],
    Ab9: ["3 4 3 4"],
    Asus: ["2 2 0 0"],
    Asus4: ["2 0 0 0"],
    "Am/G": ["2 2 3 3"],
    Bb: ["3 0 1 1"],
    Bbm: ["6 8 8 6"],
    B: ["4 1 2 2"],
    B7: ["2 1 2 2"],
    Bm: ["4 0 2 2"],
    Bb7: ["1 0 1 1"],
    "B/G": ["0 1 2 2"],
    Bbdim7: ["3 2 4 3"],
    C: ["0 2 3 0"],
    C7: ["3 2 3 3"],
    C9: ["3 0 3 0"],
    Cmaj7: ["5 5 7 7"],
    Cm: ["0 1 3 3"],
    "C#": ["1 3 4 4"],
    "C#7": ["4 3 4 4"],
    "C/B": ["5 5 7 7"],
    "C/D": ["0 0 3 0"],
    "C/G": ["0 2 3 0"],
    Cadd9: ["4 0 3 0"],
    Db: ["1 3 4 4"],
    "C#m": ["1 2 4 4"],
    Dbm: ["1 2 4 4"],
    D: ["2 0 0 2"],
    Dsus4: ["0 0 0 3"],
    Dm: ["2 0 0 1"],
    Dm7: ["2 0 3 1"],
    Dm9: ["5 3 5 0"],
    D7: ["2 0 3 2"],
    Dsus: ["7 7 5 5"],
    D7sus2: ["2 0 3 0"],
    "D/B": ["2 0 2 2"],
    "D/C#": ["2 0 4 2"],
    "D/F#": ["2 0 0 2"],
    Dmaj7: ["2 0 4 2"],
    Dbmaj7: ["6 6 8 8"],
    Eb: ["0 1 1 3"],
    Ebmaj7: ["8 8 10 10"],
    E: ["1 2 2 0"],
    E7: ["1 0 2 0"],
    Em: ["0 2 2 0"],
    "Em#5": ["0 2 2 0"],
    Em7: ["0 0 2 0"],
    Em6: ["4 5 4 0"],
    F: ["2 3 3 1"],
    F7: ["2 1 3 2"],
    "F#m": ["2 4 4 2"],
    "F#": ["6 4 4 6"],
    "F#/D": ["3 0 4 2"],
    "F#/G": ["3 4 4 3"],
    "F#m7": ["2 4 4 0"],
    Fmaj7: ["2 3 3 0"],
    F9: ["0 1 0 1"],
    Fadd9: ["0 3 0 0"],
    Gbm: ["2 4 4 2"],
    G: ["0 0 2 3"],
    G7: ["0 0 2 1"],
    Gm7: ["0 0 1 1"],
    "G#m": ["4 6 6 4"],
    "G#": ["1 1 3 4"],
    G6: ["0 0 2 0"],
    G9: ["4 3 0 3"],
    Gm: ["0 0 1 3"],
    Gmaj7: ["0 0 2 2"],
    Gb9: ["1 2 1 2"],
    "G#m7": ["1 1 2 2"],
    "G/F#": ["0 0 2 2"],
    "G/B": ["0 0 2 3"],
    "G/C": ["4 0 3 3"],
    "G/E": ["0 0 2 0"],
    "G/D": ["0 0 2 3"],
  },
};

export default chordFingerPositions;
